import React from 'react';

const Allergens = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <path
      d="M2.42 10.713c-.136-.215-.205-.323-.243-.49a1.173 1.173 0 0 1 0-.446c.038-.167.107-.275.243-.49C3.545 7.505 6.895 3 12 3s8.455 4.505 9.58 6.287c.137.215.205.323.243.49.028.125.028.322 0 .446-.038.167-.107.274-.243.49C20.455 12.495 17.105 17 12 17s-8.455-4.505-9.58-6.287Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-4 6.9c0 1.16-.895 2.1-2 2.1s-2-.94-2-2.1C4 18.39 6 15 6 15s2 3.39 2 4.9Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Allergens;
